<template>
  <Card class="dummy-page-summary">
    <div class="card-block">
      <div class="page-header-section">
        <div class="row"></div>
      </div>

      <div class="page-content-section">
        <div class="row"></div>
        <div class="row"></div>
      </div>
    </div>
  </Card>
</template>

<script>
  export default {
    name: 'dummy-page-summary',
  };
</script>

<style lang="scss">
  .dummy-page-summary {
    height: 200px;

    .page-header-section>.row {
      width: 40px;
      height: 12px;
      background-color: #f7f7f7;
      margin-bottom: 22px;
    }

    .page-content-section>.row:nth-child(1) {
      width: 540px;
      height: 12px;
      background-color: #f7f7f7;
      margin-bottom: 8px;
    }

    .page-content-section>.row:nth-child(2) {
      width: 400px;
      height: 12px;
      background-color: #f7f7f7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DummyPageSummary.vue